<template>

	<section id="WhyXRay">

		<div class="btn" @click="showPopup(1)">

			{{ $t('eightReasonsToXray') }}

		</div>

		<div class="btn" @click="showPopup(0)">

			{{ $t('howDoesItWork') }}

		</div>

		<div v-if="popupShow" class="why-popup">

			<div class="why-popup__close">

				<img src="/image/close.png" alt="Close" @click="popupShow = false" />

			</div>

			<img :src="popupImage" alt="Popup" />

		</div>

	</section>

</template>

<script>

	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				popupShow: false,
				popupImage: null
			};
		},
		methods: {
			showPopup (number) {

				this.popupImage = `/image/whyxray/${ number }.${ i18n.locale }.png`;
				this.popupShow = true;
				
			}
		}
	};

</script>
